import React from 'react';
import PropTypes from 'prop-types';

import Env from '../../../../util/env';
import {serviceURL} from '../../../../util/uiconstants';

import ProjectList from '../../../Common/ProjectList';

const OtherProjects = ({...rest}) => {
	const url = `${Env.getBaseURL(serviceURL)}projects?expand=clients,users&filter=default&includeOtherProjects=true`;

	const props = {...rest, url};

	return <ProjectList {...props} />;
};

OtherProjects.propTypes = {};

OtherProjects.defaultProps = {};

export default OtherProjects;
